import React from 'react';
import { Redirect } from 'react-router-dom';
import type { Location } from 'history';
import { useDispatch } from 'react-redux';

import { useQueryParams } from 'utils/useQueryParams';
import { storeAction } from 'entities/auth/actions';

type SingleSignOnCallbackProps = {
  location: Location;
};

const SingleSignOnCallback = ({ location: { hash } }: SingleSignOnCallbackProps) => {
  const dispatch = useDispatch();
  const queryParams = useQueryParams();

  // @NOTE-EV: TODO - settle on final redirection params name and validate
  const redirectTo = queryParams.get('d') || '/';

  dispatch(storeAction(hash.substring(1)));
  return <Redirect to={redirectTo} />;
};

export default SingleSignOnCallback;
